import { Badge } from "@/components/ui/badge";
import { Block } from "../../../types/document";
import { useAppDispatch } from "@/store/useApp";
import { useNavigate, useLocation, useParams } from "react-router";
import { Group } from "@/types/document";

interface BlockReferenceProps {
  block: Block;
  index: number;
  blockGroup: Group;
  highlight: boolean;
}

export const BlockReference = ({
  block,
  index,
  blockGroup,
  highlight,
}: BlockReferenceProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { documentId } = useParams();

  const handleClick = () => {
    // Ensure we're in reader view
    if (!location.pathname.endsWith(`/documents/${documentId}`)) {
      navigate(`/documents/${documentId}`);
    }

    // Set the selected group
    dispatch({ type: "SET_SELECTED_GROUP", payload: blockGroup });

    // Set the selected block index
    const blockIndexInGroup = blockGroup.blockIds.indexOf(block.id);
    dispatch({ type: "SET_SELECTED_BLOCK_INDEX", payload: blockIndexInGroup });
  };

  return (
    <div data-test-role="block-reference">
      <Badge
        className={`bg-blue-50 text-blue-500 font-semibold ${
          highlight ? "bg-blue-600 text-white" : ""
        }`}
      >
        B{index + 1}
      </Badge>
      <div
        onClick={handleClick}
        className="rounded-lg px-2 mb-4 mt-2 border-dashed border border-blue-500 cursor-pointer hover:bg-blue-50 transition-colors"
      >
        <p className="text-sm text-gray-700">{block.value}</p>
      </div>
    </div>
  );
};
